<div class="searchbar-container">
    @if (label()) {
        <form-label [id]="id() + '-label'" [forId]="id() + '-input'" [label]="label()"> </form-label>
    }

    <p-inputgroup
        [class.searchbar]="true"
        [class.empty]="controlValue().length === 0"
        [class.has-value]="controlValue().length > 0"
        [class.focus]="searchbarFocus()"
        [class.disabled]="disabled()">
        <input
            pInputText
            [id]="id() + '-input'"
            [(ngModel)]="controlValue"
            [type]="'text'"
            [name]="'searchValue'"
            [attr.role]="'search'"
            [attr.aria-label]="'uiKit.miscs.searchbar.inputText.ariaLabel'"
            [tabindex]="0"
            [placeholder]="placeholder() | translate"
            [maxlength]="maxLength()"
            [disabled]="disabled()"
            (keydown.enter)="search()"
            (focus)="onFocusInput()"
            (blur)="onBlurInput()"
            (input)="searchWithDebounce()"
            (ngModelChange)="checkSearchInputValue()" />
        <p-button
            [id]="id() + '-clear-icon'"
            [icon]="'fa-solid fa-xmark'"
            [tabindex]="controlValue().length === 0 || disabled() ? -1 : 0"
            [severity]="'secondary'"
            [outlined]="true"
            [text]="true"
            [size]="'large'"
            [class.clear-button]="true"
            [class.hidden]="controlValue().length === 0"
            [disabled]="disabled()"
            [attr.aria-label]="'uiKit.miscs.searchbar.button.ariaLabelClear'"
            [attr.aria-disabled]="disabled()"
            (click)="clear($event)"
            (keydown.enter)="clear($event)"></p-button>
        @if (shouldDisplaySearchIcon()) {
            <p-button
                [id]="id() + '-btn'"
                [icon]="'fa-regular fa-magnifying-glass'"
                [disabled]="disabled()"
                [loading]="isLoading()"
                [attr.aria-label]="'uiKit.miscs.searchbar.button.ariaLabelSearch'"
                [attr.aria-disabled]="disabled()"
                (click)="search()"></p-button>
        }
    </p-inputgroup>
</div>
